import { CancellablePromise } from '../../types/cancellable-promise';
import { SLMap } from '../sl-map';
import { LayerRenderResult } from '../../types/layerrenderresult';
import { EventEmitter, Output } from '@angular/core';
import { SLLayer, LayerTypeEnum } from '../sl-layer';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { ResultsService } from 'src/app/services/results.service';
import { IClearable } from 'src/app/types/iclearable';
import { ISelectionInfo, ISelectionData } from '../synchronizer';
import { MapDataAction } from '../map-actions/map_data-action';
import { ColorClass } from 'src/app/types/color-class';



export class UnSelectedResultsLayer extends SLLayer implements IClearable {

	public sourceLayer: SLLayer;
	private features: Array<any>;
	private myOpacity = 1;
	private vis = false;
	private labelVis = true;
  private _layerVis:boolean = false;
	public get layerVis() {return this._layerVis; };
  public set layerVis(vis:boolean) {this._layerVis = vis; };
	public inheritLabels = false;
	private selections: ISelectionInfo;

	public labelInfo: any = {
		labelField: '_sl_inherit_',
		labelStyleJSON: {
			font: 'RobotoBlack', size: 12, color: '#ffffff',
			align: 'center', outlinecolor: '#000000', outlinewidth: 2, shadowcolor: '#ededed',
			shadowsizex: 0, shadowsizey: 5, offsetx: 0, offsety: 20, position: 'lc'
		},
		inheritLabelStyle: true,
		inheritOnly: true,
		labelOverride: '',
		override: false,
		labelsOn: true
	};

	get layerOn(): boolean {
		return this.vis;
	}
	set layerOn(isVis: boolean) {
		this.vis = isVis;

		if (isVis && this.touched) {
			this.Render(this.SLMap);
			this.touched = false;
		} else {
			if (this.overlayLayer === undefined) {
				this.Render(this.SLMap);
			} else {
				try {
					this.overlayLayer.UpdateVisibility();
					// map.ui.getLayer(this.overlayLayer.id);
					// map.ui.setLayoutProperty(this.overlayLayer.ui.id, 'visibility', (isOn && this.parentVis) ? 'visible' : 'none');
				} catch (e) {
					// this.Render(map);
					// do nothign;
				}
			}
		}
		this.visChange.emit({ layer: this });
	}
	SetLayerOn(isVis: boolean, map: SLMap = null) {
		map = map;
		if (this.vis !== isVis) {
			this.layerOn = isVis;
		}
	}
	GetColor() {
		return this.map.styles.unselected;
	}
	get queryAble(): boolean {
		if (this.searchable === false) {
			return false;
		}
		return [
			LayerTypeEnum.Vector.valueOf(),
			LayerTypeEnum.Relational.valueOf()
		].indexOf(+this.type) > -1;
		// return (this.access >= LayerAccessLevel.Read);
	}
	get classification(): Array<ColorClass> {
		if (!this._classification) {
			this.MakeClassification();
		}
		return this._classification;
	}


	get parentLayer(): string {
		return 'results';
	}

	get searchable(): boolean {
		if ([
			LayerTypeEnum.Vector.valueOf(),
			LayerTypeEnum.Relational.valueOf()
		].indexOf(+this.type) === -1) {
			return false;
		}
		return this.data.search_on === 1;
	}

	set searchable(isSearchable: boolean) {
		this.data.search_on = isSearchable === true ? 1 : 0;
	}

	constructor(map: ISLMap, resultsSvc: ResultsService) {
		super(null, map, null, null, resultsSvc);
		this.abilities.include_in_legend = true;
		// const me = this;

	}
	SetSelections(data: ISelectionData) {
		const sameLayer = !!this.selections && this.selections?.layer && this.sourceLayer && (data.selections?.layer === this.sourceLayer);
		const hadFeatures = (!!this.selections && !!this.selections?.features && this.selections?.features?.length > 0);
		const hasFeatures = data.selections?.features?.length > 0;

		this.selections = data.selections;

		this.ShowOrHide();
		if (!this.enabled) {
			this.Clear();
		} else {
			this.Render();
		}
		MapDataAction.UpdateLayerPropertyView(this);
		if (!sameLayer || (hasFeatures && !hadFeatures)) {
			this.UpdateLegend();
		}
	}
	ShowOrHide() {
		if (!this.selections) {
			this.enabled = false;
			this.layerOn = false;
			this.layerOn = this.enabled;
			return;
		}
		if (!!this.selections.layer) {
			this.sourceLayer = this.selections.layer;
			this.data = this.sourceLayer.CloneData();
			this.icon = this.icon;
			if (!!this.selections.unfeatures) {
				if (this.selections.unfeatures.length > 0) {
					this.enabled = true;
					return;
				}
			}

		}
		this.enabled = false;
		// this.layerOn = false;


	}
	ShowResults(sourceLayer: SLLayer, gids: Array<any> = [], styles: any) {
		sourceLayer = gids = styles = null;
		/*
		this.sourceLayer = sourceLayer;
		this.data = sourceLayer.CloneData();
		this.enabled = gids.length > 0;

		this.features = gids;
		this.styles = styles;
		this.labelAttribute = this.sourceLayer.labelAttribute;
		if (this.labelAttribute === 'default') {
			if (!!this.layerAttributes) {
				if (!!this.layerAttributes.length) {
					if (this.layerAttributes.length > 0) {
						this.labelAttribute = this.layerAttributes[0].name;
					}
				}
			}
		}
		if (!this.enabled) {
			this.Clear();
		} else {
			this.Render(null);
		}
		*/
	}
	get overlayId(): string {
		return this.overlayLayer.id;
	}

	get defaultCriteria(): Array<any> | null {
		if (this.isPLayer === false) {
			return null;
		}
		return this.data.criteria;
	}
	get description(): string {
		return 'Unselected results from: ' + this.sourceLayer.name;
	}
	set description(desc: string) {
		desc = null;
		return;
	}

	get id(): string {
		return 'unsel-results';
	}

	get icon(): string {
		if (!!this.sourceLayer) {
			if (!!this.sourceLayer.icon) {

				return this.sourceLayer.icon;
			}
		}
		return '';
	}
	set icon(val: string) {
		val = val;
		this.iconChange.emit(this.icon);
	}



	get renderId() {
		return this.sourceLayer.identifier;
	}
	get plid(): string {
		return 'unsel-results';
	}
	get name(): string {
		return 'Unselected Results';
	}
	set name(name: string) {
		name = name;
		return;
	}

	get geom(): string {
		if (!!this.data) {
			return this.data.geom;
		}
		return '';
	}

	get searchtip(): string {
		return (this.data.searchtip === null) ? '' : this.data.searchtip;
	}
	set searchTip(tip: string) {
		this.data.searchTip = (tip === '') ? null : tip;
	}

	get type(): number {
		return LayerTypeEnum.Virtual_UnSelectedResults;
	}
	set type(layerType: number) {
		layerType = layerType;
	}
	get typeString(): string {
		return LayerTypeEnum[LayerTypeEnum.Virtual_SelectedResults];
	}
	get identifier() {
		if (this.isPLayer === true) {
			return this.plid;
		}
		return this.id;
	}
	get subLayers(): Array<any> {
		return [];

	}
	get subSLLayers(): Array<SLLayer> {
		return [];
	}
	get hasSubLayers(): boolean {
		return false;
	}

	Render(map: ISLMap = null, force: boolean = false) {
		if (force === true) {
			this.touched = true;
		}
		if (!this.layerOn || !this.parentVis) {
			return;
		}
		if (this.sourceLayer === undefined) {
			return;
		}
		if (map === null) {
			if (this.SLMap === undefined) {
				return;
			}
			map = this.SLMap;
		}
		if (!this.data) { return; }
		if (this.isPLayer) {
			if ((this.enabled === false) && !force) {
				this.touched = true;
				this.rendered.emit({ id: this.identifier, isPLayer: this.isPLayer, status: 'ok' });
				return;
			}
		}
		this.rendering.emit({ id: this.identifier, isPLayer: this.isPLayer });
		const handler = (result: LayerRenderResult) => {
			if (result === undefined) {
				this.rendered.emit({
					id: this.identifier,
					isPLayer: this.isPLayer,
					status: 'problem',
					error: 'There was a problem retrieving layer :' + this.name
				});
				return;
			}
			this.overlayLayer.HandleRenderResult(result);
			// this.enabled = this.features.length > 0;
			// this.layerOn = this.enabled;

		};
		const styles: any = JSON.parse(JSON.stringify({ selected: 'trans', unselected: this.map.styles.unselected })) as any;
		this.styles.unormal = '1';
		let labelsOn = this.labelsOn;
		let labelStyle = this.labelStyle;
		let labelValue = this.sourceLayer.labelOverride;
		if (this.labelInfo.override === true) {
			// labelsOn = this.labelInfo.labelsOn;
			labelStyle = this.labelInfo.labelStyleJSON;
			labelValue = this.labelInfo.labelOverride;
			this.labelAttribute = this.labelInfo.labelField;
		}
		if (this.isPLayer === true) {
			delete styles.selected;
			styles.selected = styles.unselected;
			delete styles.unselected;
			this.SLMap.component.layerAPI.RenderProjectLayerById(
				this.sourceLayer.identifier,
				map,
				this.selections.unfeatures, styles, labelsOn, undefined, JSON.stringify(labelStyle), labelValue).then(handler);
			return;
		}
		this.styles.unnormal = 1;
		const promise: CancellablePromise | void =
			this.SLMap.component.layerAPI.RenderLayerById(
				this.sourceLayer.identifier,
				map,
				this.selections.unfeatures,
				styles, this.labelsOn);
		if (promise) {
			promise.then(handler);
		}

	}
	Clear() {
		this.features = [];
		this.overlayLayer.Clear();
		this.vis = false;
		this.enabled = false;
	}

	GetFeatures(): Array<any> {
		return this.selections.unfeatures;

	}
	HasFeatures(): boolean {
		if (!this.selections) {
			return false;
		}
		if (!this.selections.unfeatures) {
			return false;
		}
		return this.selections.unfeatures.length > 0;
	}

	ZoomToFeatures() {
		this.SLMap.component.HandleToolAction({
			action: 'info/zoom-to-features',
			layer: this.sourceLayer.id,
			features: this.features.join(',')
		});



	}
	get labelsOn(): boolean {
		if (!this.parentSLLayer.labelsOn) {
			return false;
		}

		return this.labelVis;

	}
	set labelsOn(isVis: boolean) {
		this.labelVis = isVis;
	}

	get srcLabelsOn(): boolean {
		if (!this.sourceLayer) {
			return false;
		}
		return this.sourceLayer.labelsOn;
	}

	get opacity(): number {
		return this.myOpacity;
	}
	set opacity(level: number) {
		this.myOpacity = level;
		this.overlayLayer.UpdateOpacity();
		this.change$.emit(this);

	}
	SetLabelInfo(info: any) {
		this.labelInfo = info;
		this.labelsOn = info.labelsOn;
	}
	GetLabelInfo(): any {
		return this.labelInfo;
	}
	IsVirtual(): boolean {
		return true;
	}
	MakeClassification() {
		const style = this.map.styles.selected;
		const styleSections = style.split(';');

		let strokeHex = Math.round(Number(styleSections[2]) * 255).toString(16);
		if (strokeHex.length === 1) {
			strokeHex = '0' + strokeHex;
		}
		let fillHex = Math.round(Number(styleSections[1]) * 255).toString(16);
		if (fillHex.length === 1) {
			fillHex = '0' + fillHex;
		}
		const hasStroke = Number(styleSections[2]) > 0;
		let stroke = hasStroke ? styleSections[0] : 'trans';
		stroke = stroke === 'trans' ? 'trans' : stroke;// + strokeHex;
		const hasFill = Number(styleSections[1]) > 0;
		let fill = hasFill ? styleSections[0] : 'trans';
		fill = fill === 'trans' ? 'trans' : fill;// + fillHex;

		this._classification = [
			{
				crid: -1,
				criteria1: 'gid',
				criteria2: '>',
				criteria3: 0,
				description: 'Input Geometry',
				priority: 1,
				useFill: false,
				fill: 'trans',
				fillOpacity: 0,
				useStroke: hasStroke,
				stroke: (stroke),
				strokeOpacity: Number(styleSections[2]),
				field: '',
				operator: '',
				value: '',
				symbol: 'default',
				size: 4,
				useLabelStyle: this.labelsOn,
				labelStyle: this.labelStyle
			}, {
				crid: -2,
				criteria1: 'gid',
				criteria2: '>',
				criteria3: 0,
				description: 'Input Geometry',
				priority: 2,
				useFill: hasFill,
				fill: (fill),
				fillOpacity: Number(styleSections[1]),
				useStroke: false,
				stroke: 'trans',
				strokeOpacity: 0,
				field: '',
				operator: '',
				value: '',
				symbol: 'default',
				size: 4,
				useLabelStyle: false,
				labelStyle: ''
			}
		];
	}
	GetSourceLayer() {
		return this.sourceLayer;
	}
}

